module.exports = __webpack_public_path__ + "img/2.374782c3.jpg";